// extracted by mini-css-extract-plugin
module.exports = {"content":"privacy-module--content--3thYp"};